"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ConsumerDisruptionContext_1 = require("./ConsumerDisruptionContext");
/**
 * @description React Hook that tracks if banner is open. Uses Provider Context if available.
 * @returns A tuple returning isOpen and setIsOpen.
 */
var useConsumerDisruptionContext = function () {
    var context = (0, react_1.useContext)(ConsumerDisruptionContext_1.ConsumerDisruptionContext);
    if (context) {
        return [context.isOpen, context.setIsOpen];
    }
    var _a = (0, react_1.useState)(true), isOpen = _a[0], setIsOpen = _a[1];
    return [isOpen, setIsOpen];
};
exports.default = useConsumerDisruptionContext;
